const TITLE_KEYS = {
  404: 'layouts.error.pageNotFoundTitle',
  410: 'layouts.error.pageNotFoundTitle',
  451: 'layouts.error.countryRestrictedMetaTitle',
}

export const errorTitleKey = statusCode =>
  TITLE_KEYS[statusCode] || 'layouts.error.errorTitle'

export const errorHeadMeta = t => [
  { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
  {
    hid: 'description',
    name: 'description',
    content: t('layouts.error.metaDescription'),
  },
]
